<template>
  <layout>
    <span slot="header">{{ title }}
      <button class="btn-pop-close delete" aria-label="close" @click="$parent.close()"></button>
      <i class="fas fa-print" style="font-size: 22px !important; float: right; margin-right: 70px;" @click="goPrint"></i>
    </span>
    <div slot="content" v-for="(item, i) in asRepair" :key="i">
      <div id="printf">
        <repairScreen :asRepair="item" :idx="i" :asItem="asItem"/>
      </div>
    </div>
  </layout>
</template>

<script>
/**
 * * components
 */
import Layout from '@/components/Slot/ModalSlot.vue';
import RepairScreen from '@/components/RepairScreen/RepairScreen2.vue';
/**
 * lodash
 */
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  components: {Layout, RepairScreen},
  props: {
    data: {
      Type: Object,
      default: {
        asId: ''
      }
    }
  },
  data() {
    return {
      title: '수리내역서',
      rowData: [],
      asRepair : [],
      asItem : [],
      form : {
        companyId : '',
        asId: '',
        processTime : ''

      },
    }
  },
  mounted() {
    this.form.companyId = this.$store.state.loginInfo.compCd;
    this.form.asId = this.data.asId;
    this.getAsRepairDetailInfo();
    this.getAsRepairItemInfo();
  },
  computed: {
    printStyle() {
      return `body {
          width: 100%;
          height: 100%;
          background-color: #FAFAFA;
          text-align: -webkit-center;
          font: 9pt "Tahoma";
        }
        * {
          box-sizing: border-box;
          -moz-box-sizing: border-box;
        }
        tr {
            display: table-row;
            vertical-align: inherit;
            border-color: inherit;
        }
        .page {
          width: 210mm;
          min-height: 297mm;
          padding: 0mm;
          margin: 0mm auto;
          border: 1px #D3D3D3 solid;
          border-radius: 5px;
          background: white;
          box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
        }
        .subpage {
          padding: 1cm;
          border: 5px red solid;
          height: 257mm;
          outline: 2cm #FFEAEA solid;
        }
        @page {
          size: A4;
          margin: 0;
        }
        @media print {
          html, body {
            width: 210mm;
            height: 297mm;
          }
          .page {
            margin: 0;
            border: initial;
            border-radius: initial;
            width: initial;
            min-height: initial;
            box-shadow: initial;
            background: initial;
            page-break-after: always;
          }
        }`
    }
  },
  methods: {
    goPrint(){

      var printDiv = document.getElementById("printf");
      var pop = window.open(this.url, '_blank');

      // pop.document.write('<html><head><title></title><link rel="stylesheet" type="text/css" href="/css/common.css"></head><body>');
      // pop.document.write(printDiv.innerHTML);
      // pop.document.write('</body></html>');
      pop.document.write(`<!DOCTYPE html><head><meta charset="utf-8"><title>LUCOMS 서비스</title></head><body>`);
      pop.document.write(printDiv.innerHTML);
      pop.document.write(`</body>
        <style>
        ${this.printStyle}
        </style>
      </html>`);

      pop.document.close();

      setTimeout(function() {
        pop.print();
        pop.close();
      }, 100);

    },
    getAsRepairDetailInfo(){

      let that = this
      this.$store.commit('loading')

      const vForm = {
        companyId :this.form.companyId,
        asId: this.form.asId,
        processTime : this.form.processTime
      }
      this.$http.post(_url("/api/workMng/callDispose/aslist"), vForm).then(response => {
        this.asRepair = response.data
        /* data customize */
      }).finally(() => {
        this.$store.commit('finish')
      });

    },
    getAsRepairItemInfo(){

      let that = this
      this.$store.commit('loading')

      const vForm = {
        companyId :this.form.companyId,
        asId: this.form.asId,
        processTime : this.form.processTime
      }
      this.$http.post(_url("/api/workMng/callDispose/asItemlist"), vForm).then(response => {
        this.asItem = response.data
      }).finally(() => {
        this.$store.commit('finish')
      });

    },

  },
}
</script>